import {
    QueryErpItemParam,
    QueryErpItem,
    GetProcessUsingGet2Params,
    ExcelImportStatus,
    ErpSkuImportContext,
    DistributorErpSkuImportContext,
    GetProcessUsingGetParams,
    GetCacheShareShopItemUsingGetParams,
    InnerOpenShareShopItemVo,
    GetCacheShareItemUsingGetParams,
    InnerOpenShareItemVo,
    GetCacheShareSpuUsingGetParams,
    InnerOpenShareSpuVo,
    ShareErpItemParamVo,
    QueryTaskUsingGet2Params,
    RedisProgressInfo,
    ItemCodeCheckResult
} from '@servicesTypings/goodsRequestV3'
import { goodsRequest } from '@/utils/request'

// 查询ERP商品
/**
 * 获取用户ERP商品列表
 */
export function queryTable(data: QueryErpItemParam): API.Res<QueryErpItem[]> {
    return goodsRequest.post('/erpGoods/getList', { data })
}

// 查询ERP商品导入进度
/**
 * 获取进度条
 */
export function queryProcess(params: GetProcessUsingGet2Params): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/erpGoods/getProcess', { params })
}

/**
 * @description:  导入全部
 */
/**
 * erp商品全量导入
 */
export function importAll(data: ErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/erpGoods/import/all', { data })
}

/**
 * @description:  批量导入
 */
/**
 * erp商品批量导入
 */
export function batchImport(data: ErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/erpGoods/import/batch', { data })
}

/**
 * @description:  单个导入
 */
/**
 * erp商品单个导入
 */
export function singleImport(data: ErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/erpGoods/import/single', { data })
}

/**
 * @description:  导入全部【sku】
 */
/**
 * 全量导入
 */
export function importAllSku(data: DistributorErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/distributor/erp/sku/import/all', { data })
}

/**
 * @description:  批量导入【sku】
 */
/**
 * 批量导入
 */
export function batchImportSku(data: DistributorErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/distributor/erp/sku/import/batch', { data })
}

/**
 * @description:  单个导入【sku】
 */
/**
 * 单个导入
 */
export function singleImportSku(data: DistributorErpSkuImportContext): API.Res<string> {
    return goodsRequest.post('/distributor/erp/sku/import/single', { data })
}

// 查询ERP商品导入进度【sku】
/**
 * 获取进度条
 */
export function queryProcessSku(params: GetProcessUsingGetParams): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/distributor/erp/sku/import/getProcess', { params })
}

// 获取ERP分享店铺商品资料参数
/**
 * 获取ERP分享店铺商品资料参数
 */
export function getCacheShareShopItem(params: GetCacheShareShopItemUsingGetParams): API.Res<InnerOpenShareShopItemVo> {
    return goodsRequest.get('/mall/shareErpItem/getCacheShareShopItem', { params })
}

// 获取ERP分享普通商品资料参数
/**
 * 获取ERP分享普通商品资料参数
 */
export function getCacheShareItem(params: GetCacheShareItemUsingGetParams): API.Res<InnerOpenShareItemVo> {
    return goodsRequest.get('/mall/shareErpItem/getCacheShareItem', { params })
}

// 获取ERP分享按款普通商品资料参数
/**
 * 获取ERP分享按款普通商品资料参数
 */
export function getCacheShareSpu(params: GetCacheShareSpuUsingGetParams): API.Res<InnerOpenShareSpuVo> {
    return goodsRequest.get('/mall/shareErpItem/getCacheShareSpu', { params })
}

// 分享erp商品
/**
 * 分享erp商品
 */
export function shareErpItem(data: ShareErpItemParamVo): API.Res<string> {
    return goodsRequest.post('/mall/shareErpItem/share', { data })
}

// 分享erp商品查询分销进度
/**
 * 分享erp商品查询分销进度
 */
export function queryTask(params: QueryTaskUsingGet2Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/mall/shareErpItem/queryTask', { params })
}

/**
 * 参数都是必填
 */
export function checkRepeatByQueryUsingPOST(data: ErpSkuImportContext): API.Res<ItemCodeCheckResult> {
    return goodsRequest.post('/erpGoods/import/checkRepeatByQuery', { data })
}

/**
 * 参数都是必填
 */
export function checkRepeatUsingPOST(data: ErpSkuImportContext): API.Res<ItemCodeCheckResult> {
    return goodsRequest.post('/erpGoods/import/checkRepeat', { data })
}
